'use strict';

angular.module('internal.services')
    .controller('InternalServiceUsersLongevity', ['$scope', '$stateParams', '$q', 'ServiceUserLongevities', 'Users', '$state', function ($scope, $stateParams, $q, ServiceUserLongevities, Users, $state) {
        $scope.resetService();
        $scope.longevity = $stateParams.longevity;
        $scope.longevityID = $stateParams.longevityID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        var promises = [];

        promises.push(Users.get({ service_id: $scope.serviceID, inactiveServiceUsers: true, longevityGet: true }).then(function (service_users) {
            $scope.service_users = service_users;
            $scope.loading = false;
        }))

        if ($stateParams.longevityID != null) {
            promises.push(ServiceUserLongevities.getByID($stateParams.longevityID).then(function (longevity) {
                $scope.longevity = longevity;
                $scope.longevity.credit_awarded_date = $scope.longevity.awarded_date || new Date();
            }))
        }
        else {
            $scope.longevity = { service_id: $scope.serviceID, credit_awarded_date: new Date() };
        }

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.save = function () {
            $scope.saving = true;

            ServiceUserLongevities.save($scope.longevity).then(function () {
                $scope.saving = false;
                $state.go('internal.licensing.service.users.longevities', { id: $scope.serviceID });
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this service longevity credit?')) {
                ServiceUserLongevities.delete($scope.longevityID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.service.users.longevities', { id: $scope.serviceID });
                })
            }
            else {
                $scope.deleting = false;
            }
        }
    }])
;